import styled from 'styled-components';

export const IconLabelContainer = styled.div`
  display: flex;
  gap: 8px;
`;
